import React from "react";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";

const fmtK = (n) => (n >= 1000 ? `${(n / 1000).toFixed(1)}K` : `${n}`);

export function PopularLiveThumb({ item }) {
  return (
    <Link
      to={`/live/${item.liveId}`}
      data-testid={`popular-thumb-${item.id}`}
      className="group relative block aspect-video overflow-hidden rounded-xl bg-[#0A1526] shadow-sm ring-1 ring-black/5"
    >
      <img
        src={item.thumbnail}
        alt={item.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-black/10" />

      <span className="absolute left-2.5 top-2.5 inline-flex items-center gap-1.5 rounded-full bg-live px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
        <span className="h-1.5 w-1.5 rounded-full bg-white" /> {fmtK(item.viewers)}
      </span>
      <span className="absolute right-2.5 top-2.5 inline-flex items-center gap-1 rounded-full bg-black/55 px-2 py-0.5 text-[11px] font-semibold text-white backdrop-blur-md">
        <Eye className="h-3 w-3" /> {fmtK(item.views)}
      </span>

      <span className="absolute bottom-2.5 left-2.5 right-2.5 line-clamp-1 text-xs font-semibold text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">
        {item.title} · {item.city}
      </span>
    </Link>
  );
}

export default PopularLiveThumb;
